import React from 'react';
import ReactDOM from 'react-dom';
import { enableES5 } from 'immer';
import { overrideComponent, postVerificationSizeUpdates, setOptions } from '@sheerid/jslib';

import './index.css';
import App from './App';

import { defaultOptions } from './programOptions';
import { googleTagManagerHook } from './hooks/hooks';
import { StepStudentPersonalInfoComponent } from './components/Steps/StepStudentPersonalInfoComponent';
import { StepErrorComponent } from './components/Steps/StepErrorComponent';
import { isQueryStringValid, addMetadataFromQueryString } from './lib/utils/browser';
import { StepSuccessComponent } from './components/Steps/StepSuccessComponent';
import { StepPendingComponent } from './components/Steps/StepPendingComponent';

setOptions(defaultOptions);
googleTagManagerHook();
postVerificationSizeUpdates();
enableES5();

if (isQueryStringValid()) {
    overrideComponent('StepStudentPersonalInfoComponent', StepStudentPersonalInfoComponent);
    addMetadataFromQueryString();
} else {
    overrideComponent('StepStudentPersonalInfoComponent', StepErrorComponent);
}
overrideComponent('StepSuccessComponent', StepSuccessComponent);
overrideComponent('StepPendingComponent', StepPendingComponent);

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById('root'),
);
